import { render, staticRenderFns } from "./menuPane.vue?vue&type=template&id=20b36737&scoped=true"
import script from "./menuPane.vue?vue&type=script&lang=js"
export * from "./menuPane.vue?vue&type=script&lang=js"
import style0 from "./menuPane.vue?vue&type=style&index=0&id=20b36737&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b36737",
  null
  
)

export default component.exports